/**
 * Collapse content
 */
const $ = window.jQuery;
const EXPANDED_CLASS = 'expanded';

export default {
    attach: function (context, settings) {
        let $newContent = $(context);
        let $collapseContent = $newContent.find('.collapse-uri');
        let id = "collapse-uri-";

        if ($collapseContent.length > 0) {
            $collapseContent.each(function(index, item) {
               let $item = $(item);
               id = id + index;

               // Initialize collapse content.
               Drupal.behaviors.collapseContent.init($item, id);
            });
        };
    },
    /**
     * Init accordion.
     * @param $collapse
     * @param id
     */
    init: function($collapse, id) {
        let $collHeader = $collapse.find('.collapse-header');
        let $button = $collHeader.find('button');
        let $collContent = $collapse.find('.collapse-content');
        let panelId = id + '-panel';

        if ($button.length > 0 && $collContent.length > 0) {
            let expanded = $collContent.hasClass(EXPANDED_CLASS);

            // Init state - check expanded class.
            if (!expanded) $collContent.css('display', 'none');
            if (expanded) {
                $collContent.css('display', 'block');
                $button.attr('aria-expanded', true);
            };

            // Setting aria attributes.
            $button.attr('id', id);
            $button.attr('aria-controls', panelId);
            $button.attr('aria-expanded', expanded);

            $collContent.attr('id', panelId);
            $collContent.attr('aria-labelledby', id);

            // On button click.
            $button.on('click', function (event) {
                event.preventDefault();

                // Toggle expaded class.
                $collContent.toggleClass(EXPANDED_CLASS);

                // Set right aria attributes.
                if ($collContent.hasClass(EXPANDED_CLASS)) {
                    $button.attr('aria-expanded', true);
                    $collContent.show("slow");
                }
                else {
                    $button.attr('aria-expanded', false);
                    $collContent.slideUp("slow");
                }
            })
        };
    },
}
